import React, { useEffect, useState } from 'react';

/**
 * Loads the Cashfree JS SDK and exposes the global Cashfree class.
 * Returns { loaded, error, Cashfree } where Cashfree is the constructor function.
 */
export function useCashfreeSdk() {
  const [loaded, setLoaded] = useState(typeof window !== 'undefined' && !!window.Cashfree);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.Cashfree) {
      setLoaded(true);
      return;
    }
    const existing = document.querySelector('script[data-cashfree-sdk]');
    if (existing) {
      existing.addEventListener('load', () => setLoaded(true));
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
    script.async = true;
    script.setAttribute('data-cashfree-sdk', '1');
    script.onload = () => setLoaded(true);
    script.onerror = () => setError(new Error('Failed to load Cashfree SDK'));
    document.body.appendChild(script);
  }, []);

  return {
    loaded,
    error,
    Cashfree: typeof window !== 'undefined' ? window.Cashfree : null,
  };
}
